import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux'
import { RouterProvider } from "react-router";
import { ThemeProvider } from '@mui/material/styles';
import store from './store/store';
import routes from "./routes/routes";
import theme from './theme/index';
import { initGtm } from './services/gtm';
import { initTrustedTypesPolicy } from './utils/trustedTypesPolicy';
import './typography.scss';
import "./index.scss";
// import './plugins/i18n';

initTrustedTypesPolicy();

const container = document.getElementById("root") as HTMLElement;
initGtm();

const root = createRoot(container);

root.render(
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <RouterProvider router={routes}/>
      </Provider>
    </ThemeProvider>
);
